import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <h1 className="privacy-title">Privacy Policy</h1>
        <div className="privacy-content">
          <section className="privacy-section">
            <h2>Pesa Guide App Privacy Commitment</h2>
            <p>We are committed to providing financial guidance and expert advice while respecting your privacy. Our app is designed to educate and inform without collecting or storing any personal or financial information.</p>
          </section>
          <section className="privacy-section">
            <h2>App Functionality</h2>
            <p>The Pesa Guide App is an informational tool that provides:</p>
            <ul className="privacy-list">
              <li>General financial guidance and educational content</li>
              <li>Expert advice and best practices for financial management</li>
              <li>Financial planning resources and tools</li>
              <li>Educational materials about personal finance</li>
            </ul>
          </section>
          <section className="privacy-section">
            <h2>Data Collection</h2>
            <p>Our app does not collect, store, or process any personal or financial information from users. All content is provided for educational and informational purposes only, without requiring any user data input.</p>
          </section>
          <section className="privacy-section">
            <h2>Third-Party Links</h2>
            <p>Our app may contain links to external resources and websites. Please note that this privacy policy applies only to our app. We encourage users to read the privacy policies of any external sites they visit through our app.</p>
          </section>
          <section className="privacy-section">
            <h2>App Permissions</h2>
            <p>The only permissions our app requires are:</p>
            <ul className="privacy-list">
              <li>Internet access - to provide up-to-date financial guidance</li>
              <li>Storage access - to cache educational content for offline viewing</li>
            </ul>
          </section>
          <section className="privacy-section">
            <h2>Children's Privacy</h2>
            <p>Our app is designed for general audiences and provides financial education content. We do not collect any personal information from users of any age, including children under 13.</p>
          </section>
          <section className="privacy-section">
            <h2>Contact Us</h2>
            <p>For any questions or concerns about our privacy policy, please contact us at:</p>
            <div className="contact-info">
              <p>Email: privacy@pesaguide.com</p>
            </div>
          </section>
          <div className="privacy-footer">
            <p>Last updated: December 15, 2024</p>
            <button className="privacy-button" onClick={() => window.print()}>
              Print Policy
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
